import { helpers, required } from '@vuelidate/validators';

export const validationModel = {
  noteText: {
    isRequired: helpers.withMessage('Note is required', required),
  },
};
